<template>
    <div class="memberinfo">
        <table class="main-information" v-if="status">
            <tbody>
                <tr>
                    <td>用户名:</td>
                    <td>{{login_name}}</td>
                    <td></td>
                    <td>会员组:</td>
                    <td>{{group}}</td>
                </tr>
                <tr>
                    <td>电子邮箱:</td>
                    <td>{{email}}</td>
                    <td></td>
                    <td>有效期:</td>
                    <td>{{end_time}}</td>
                </tr>
                <tr>
                    <td>单位或姓名:</td>
                    <td>{{user_name}}</td>
                    <td></td>
                    <td>专业方向:</td>
                    <td>{{major}}</td>
                </tr>
                <tr>
                    <td>联系电话:</td>
                    <td>{{phone}}</td>
                    <td></td>
                    <td>QQ号码:</td>
                    <td>{{qq}}</td>
                </tr>
                <tr>
                    <td>并发线程数:</td>
                    <td>{{enable}}</td>
                    <td></td>
                    <td>登录次数:</td>
                    <td>{{login_count}}</td>
                </tr>
                <tr>
                    <td>上次登录时间:</td>
                    <td>{{last_login_time}}</td>
                    <td></td>
                    <td>上次登录IP:</td>
                    <td>{{cur_login_ip}}</td>
                </tr>
                <tr>
                    <td>本次登录时间:</td>
                    <td>{{cur_login_time}}</td>
                    <td></td>
                    <td>本次登录IP:</td>
                    <td>{{last_login_ip}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                status: false,
                login_name: null,
                group: null,
                email: null,
                end_time: null,
                user_name: null,
                major: null,
                phone: null,
                qq: null,
                enable: null,
                login_count: null,
                cur_login_time: null,
                cur_login_ip: null,
                last_login_time: null,
                last_login_ip: null,
            }
        },
        created () {
            this.$http.getUserInfo().then(response => {
                if (response.code===200) {
                    // 把得到的数据传入到页面中
                    this.login_name = response.data.login_name
                    this.group = response.data.group
                    this.email = response.data.email
                    this.end_time = response.data.end_time
                    this.user_name = response.data.user_name
                    this.major = response.data.major
                    this.phone = response.data.phone
                    this.qq = response.data.qq
                    this.enable = response.data.enable
                    this.login_count = response.data.login_count
                    this.cur_login_time = response.data.cur_login_time
                    this.cur_login_ip = response.data.cur_login_ip
                    this.last_login_time = response.data.last_login_time
                    this.last_login_ip = response.data.last_login_ip
                    this.status = true;
                }
            }).catch(err => {
                this.$message.error('获取失败');
            })
        }
    }
</script>
<style scoped>
    .memberinfo {
        display: flex;
        width: 1030px;
        margin: 0 auto;
    }
    .main-information {
        font-size: 15px;
        margin-top: 50px;
    }
    .main-information tr>td:nth-child(1),
    .main-information tr>td:nth-child(4){
        width:200px;
        padding: 15px 0 15px 40px;
    }
    .main-information tr>td:nth-child(3){
        width: 200px;
    }
    .main-information tr>td:nth-child(2),
    .main-information tr>td:nth-child(5){
        width:250px;
    }
</style>